angular.module('rightPaneModule')
  .controller('ClassroomPerformanceController', ['$scope', 'studentApi', function($scope, $studentApi) {

    $scope.years = { list: null, selected: {} };

    $scope.timeframes = {
      list: [
        { id: '30d', name: 'Last 30 Days', by: 'week', active: true },
        { id: '60d', name: 'Last 60 Days', by: 'week', active: false },
        { id: '90d', name: 'Last 90 Days', by: 'month', active: false }
      ],
      selected: {}
    };

    var updateClusterData = function() {
      $studentApi.getStudentsClusterData(function(graphData) {
        $scope.graphData = graphData;
      });
    };

    var initializeData = function(e, item) {
      $scope.item = item;
      updateClusterData();
    };

    $scope.$on('itemReady', initializeData);

    $scope.$on('listTableRowClicked', function(e, item) {
      $scope.$emit('route', item);
    });


    $scope.$on('yearSelected', updateClusterData);

    $scope.$on('timeframeSelected', updateClusterData);

    $scope.$on('updateYears', function(e, years) {
      $scope.years.list = angular.copy(years);
    });

  }]);
